export default __webpack_public_path__ + "static/media/307.e9790b40.gif";